import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import "../css/privacy.scss";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="privacy">
      <Header />

      <main>
        <div className="grid grid-cols-1 overflow-x-hidden ">
          <div>
            <div className="md:px-8 lg:px-12   ">
              <div className="pt-6">
                <div className="">
                  <div
                    __typename="ComponentComponentsText"
                    container="[object Object]"
                    id={5536}
                  >
                    <div className="prose prose-plain max-w-full prose-h1:font-heading text-left text-base font-normal p-4">
                      <h2>Privacy Notice</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Here at boventraix.space UK Ltd (‘Boventraix’) We are
                          committed to protecting and respecting the privacy of
                          your personal data. This privacy notice explains how
                          your data is collected, used, transferred and
                          disclosed by us. It applies to data collected when you
                          use our websites, iOS and android applications, when
                          you interact with us through social media, email, or
                          phone, or when you participate in our competitions or
                          events. It also applies to the extent that someone has
                          nominated you through our "refer a friend" function or
                          purchased an e-gift card on your behalf. It covers:
                        </p>
                      </div>
                      <ul>
                        <li>The personal data we collect</li>
                        <li>How we collect your data</li>
                        <li>How we use your data</li>
                        <li>Marketing preferences, adverts and cookies</li>
                        <li>Links to other websites and third parties</li>
                        <li>How we share your data</li>
                        <li>Your rights</li>
                        <li>Changes to this privacy notice</li>
                        <li>How to contact us</li>
                      </ul>
                      <h3>Who is Boventraix</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Boventraix is a leading online fashion retail company.
                          We design, source, market and sell clothing, shoes,
                          accessories and beauty products targeted at 16-24
                          year-old consumers in almost every country in the
                          world.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          boventraix.space UK Ltd jointly controls and is
                          jointly responsible with Debenhams Retail Online
                          Limited for the processing of your personal data
                          collected through the www.boventraix.space website
                          (the “website”) and our associated brand app (the
                          “app”). Debenhams Retail Online Limited will offer
                          various brands that we operate which include:
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Oasis
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Coast
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Dorothy Perkins
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Wallis
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Burton
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Boventraix
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Prettylittlething
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Boventraix
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Karen Millen
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Nasty Gal
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Miss Pap
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Warehouse
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Debenhams
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          References to "we", "us", and / or "our" are to the
                          companies that make up the group of companies.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Details of our Data Protection Officer responsible for
                          overseeing questions in relation to this privacy
                          notice including how your data is processed by
                          companies in the group, and our details are set out in
                          the “How to Contact Us” section at the end of this
                          notice.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Concessionaire Brands
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          On the website, we make available products that are
                          sold to you by us or, alternatively, by a third party
                          retailer (a “Concessionaire Brand”). In relation to
                          products that are sold by a Concessionaire Brand, the
                          relevant Concessionaire Brand will be responsible for
                          your order. We will tell you on our website if a
                          product is sold by a Concessionaire Brand and provide
                          you with the name of the Concessionaire Brand. Our
                          privacy notice explains what personal data we share
                          with the Concessionaire Brands in order to ensure they
                          are able to fulfil their obligations to you.
                        </p>
                      </div>
                      <h3>Our commitment to you</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We take the protection of your personal data seriously
                          and will process your personal data fairly, lawfully
                          and transparently. This privacy notice describes the
                          personal data we are collecting about you and how it
                          is used.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We will only collect and use your personal data for
                          the following purposes, to:
                        </p>
                      </div>
                      <ul>
                        <li>fulfil your order(s)</li>
                        <li>
                          fulfil orders made on your behalf (e.g. e-gift card
                          orders)
                        </li>
                        <li>
                          communicate with you following a "refer a friend"
                          nomination
                        </li>
                        <li>
                          keep you up to date with the latest offers and trends
                        </li>
                        <li>give you a better shopping experience</li>
                        <li>
                          help us to make our marketing more relevant to you and
                          your interests
                        </li>
                        <li>improve our services</li>
                        <li>meet our legal responsibilities</li>
                      </ul>
                      <h3>How we keep your data safe and secure</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We have appropriate organisational safeguards and
                          security measures in place to protect your data from
                          being accidentally lost, used or accessed in an
                          unauthorised way, altered or disclosed.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          The communication between your browser and our website
                          uses a secure encrypted connection wherever your
                          personal data is involved.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We require any third party who is contracted to
                          process your personal data on our behalf to have
                          security measures in place to protect your data and to
                          treat such data in accordance with the law.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          In the unfortunate event of a personal data breach, we
                          will notify you and any applicable regulator when we
                          are legally required to do so.
                        </p>
                      </div>
                      <h3>The personal data we collect</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Personal data means any information about an
                          individual from which that person can be identified.
                          It does not include anonymised data, where the
                          identity and identifying information has been removed.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          While our website is designed for a general audience,
                          we will not knowingly collect any data from children
                          under the age of 13 or sell products to children. If
                          you are under the age of 13, you are not permitted to
                          use or submit your data to the website.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          The following groups of personal data are collected:
                        </p>
                      </div>
                      <ul>
                        <li>
                          Identity Data includes information such as: first
                          name, last name, title, date of birth (optional),
                          occupation, personal description, photo and gender.
                        </li>
                        <li>
                          Contact Data includes information such as: email
                          address, billing address, delivery address, location,
                          country, telephone number, loyalty programme
                          membership number, and social media id (if you log in
                          by social media).
                        </li>
                        <li>
                          Financial Data includes information such as: payment
                          card details and bank account.
                        </li>
                        <li>
                          Transaction Data includes information such as: details
                          of your purchases and the fulfilment of your orders
                          (such as basket number, order number/reference,
                          subtotal, title, currency, discounts, shipping
                          (including tracking information, order status), number
                          of items, product number, single item price, category,
                          tax etc.); payments to and from you and details of
                          other products and services you have obtained from us,
                          information relating to returns, correspondence or
                          communications with you in respect of your orders, and
                          details of any rewards and bonuses awarded.
                        </li>
                        <li>
                          Technical Data includes information such as: details
                          of the device(s) you use to access our services, your
                          internet protocol (IP) address, login data, your
                          username and password, browser type and version, time
                          zone setting and location, browser plug-in types and
                          versions, operating system and platform.
                        </li>
                        <li>
                          Profile Data includes information such as: purchases
                          or orders made by you, product and style interests,
                          preferences, feedback, and survey responses.
                        </li>
                        <li>
                          Usage Data includes information such as: how and when
                          you use our website/app, how you moved around it, what
                          you searched for; website/app performance statistics,
                          traffic, location, eblogs and other communication
                          data; loyalty programme activities; and details of any
                          other Debenhams products and services used by you.
                        </li>
                        <li>
                          Marketing and Communications Data includes information
                          such as: your preferences in receiving marketing from
                          us and our third parties and your communication
                          preferences.
                        </li>
                      </ul>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We also collect, use and share Aggregated Data such as
                          statistical or demographic data for any purpose.
                          Aggregated Data may be derived from your personal data
                          but is not considered personal data as this data does
                          not directly or indirectly reveal your identity. For
                          example, we may aggregate your Usage Data to calculate
                          the percentage of users accessing a specific website
                          feature. However, if we combine or connect Aggregated
                          Data with your personal data so that it can directly
                          or indirectly identify you, we treat the combined data
                          as personal data which will be used in accordance with
                          this privacy notice. ㅤ We do not collect any Special
                          Categories of Personal Data about you (this includes
                          details about your race or ethnicity, religious or
                          philosophical beliefs, sex life, sexual orientation,
                          political opinions, trade union membership,
                          information about your health, and genetic and
                          biometric data). Nor do we collect any information
                          about criminal convictions and offences.
                        </p>
                      </div>
                      <h3>If you fail to provide personal data</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Where we need to collect personal data by law, or
                          under the terms of a contract we have with you, and
                          you fail to provide that data when requested, we may
                          not be able to perform the contract we have or are
                          trying to enter into with you (for example, to provide
                          you with products you have ordered from us). In this
                          case, we may have to cancel a product or service you
                          have with us but we will notify you if this is the
                          case at the time.
                        </p>
                      </div>
                      <h3>How we collect your data</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We may collect personal data about you in the
                          following ways:
                        </p>
                      </div>
                      <ul>
                        <li>
                          Direct interactions – you may give us your Identity,
                          Contact, Financial, Transaction, Profile, and
                          Marketing and Communications data (as described above)
                          by filling in forms, entering information online or by
                          corresponding with us by post, phone, email, telephone
                          or otherwise. This includes personal data you provide,
                          for example, when you:
                        </li>
                        <li>
                          Create an account or purchase products on our website;
                        </li>
                        <li>
                          Subscribe to our newsletter, discussion boards, social
                          media sites or create wish lists;
                        </li>
                        <li>Enter a competition;</li>
                        <li>Join a Debenhams loyalty programme;</li>
                        <li>Complete a voluntary market research survey;</li>
                        <li>
                          Contact us with an enquiry or to report a problem (by
                          phone, email, social media, or messaging service);
                        </li>
                        <li>
                          Use the “refer a friend” function on our website; or
                        </li>
                        <li>
                          When you log in to our website via social media.
                        </li>
                        <li>
                          Automated technologies or interactions – as you
                          interact with our website, we may automatically
                          collect the following types of data (all as described
                          above): Technical Data about your equipment, Usage
                          Data about your browsing actions and patterns, and
                          Contact Data where tasks carried out via our website
                          remain uncompleted, such as incomplete orders or
                          abandoned baskets. We collect this data by using
                          cookies, server logs and other similar technologies.
                          Please see our Cookie Policy for further details.
                        </li>
                        <li>
                          Third parties – we may receive personal data about you
                          from various third parties, including:
                        </li>
                      </ul>
                      <ol>
                        <li>
                          Identity and Contact data from another individual when
                          they purchase an e-gift card for you or use the "refer
                          a friend" function on our website;
                        </li>
                        <li>
                          Technical Data from third parties, including analytics
                          providers such as Google. Please see further
                          information in the section entitled ‘Marketing
                          preferences, adverts and cookies’.
                        </li>
                        <li>
                          Technical Data from affiliate networks through whom
                          you have accessed our website;
                        </li>
                        <li>
                          Identity and Contact Data from social media platforms
                          when you log in to our website using such social media
                          platforms;
                        </li>
                        <li>
                          Identity and Contact data from third parties,
                          including organisations (including law enforcement
                          agencies), associations and groups, who share data for
                          the purposes of fraud prevention and detection and
                          credit risk reduction;
                        </li>
                        <li>
                          Contact, Financial and Transaction Data from providers
                          of technical, payment and delivery services; and
                        </li>
                        <li>
                          Identity, Contact and Transaction Data from
                          Concessionaire Brands who will be responsible for your
                          contract and fulfilling your order if you purchase a
                          product from one or more of the Concessionaire Brands
                          on our website (so that we can, for example, carry out
                          invoice reconciliation, receive updates on the status
                          of the order, and assist with dealing with any
                          complaints or issues with the products purchased).
                        </li>
                      </ol>
                      <h3>How we use your data</h3>
                      <h4>The legal basis for processing your personal data</h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We will only collect and process your personal data
                          where we have a legal basis to do so. As a data
                          controller, the legal basis for our collection and use
                          of your personal data varies depending on the manner
                          and purpose for which we collected it.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We will only collect personal data from you when:
                        </p>
                      </div>
                      <ul>
                        <li>
                          we have your consent to do so (including, in respect
                          of direct marketing, where you have not chosen to
                          opt-out of such marketing); or
                        </li>
                        <li>
                          we need your personal data to perform a contract with
                          you. For example, to process a payment from you,
                          fulfil your order or provide customer support
                          connected with an order, or
                        </li>
                        <li>
                          the processing is in our legitimate interests and not
                          overridden by your rights, or
                        </li>
                        <li>
                          we have a legal obligation to collect or disclose
                          personal data from you.
                        </li>
                      </ul>
                      <h4>Uses made of your personal data</h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Your personal data is used by Debenhams to support a
                          range of different activities. These are listed in the
                          table below together with the types of data used and
                          the legal bases we rely on when processing them,
                          including where appropriate, our legitimate interests.
                          Please be aware that we may process your personal data
                          using more than one lawful basis, depending on the
                          specific activity involved. Please contact us if you
                          need details about the specific legal ground we are
                          relying on to process your personal data where more
                          than one ground has been set out in the table below.
                        </p>
                      </div>
                      <table>
                        <thead>
                          <tr>
                            <th>Purpose/Activity</th>
                            <th>Type of data</th>
                            <th>
                              Lawful basis for processing including basis of
                              legitimate interest
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              To create an account and register you as a new
                              customer (either directly or via social media).
                            </td>
                            <td>Identity . Contact</td>
                            <td>Consent</td>
                          </tr>
                          <tr>
                            <td>
                              (1) To process and deliver your order including:
                              recording your order details; keeping you informed
                              about the order status; process payments and
                              refunds, collect money owed to us; and
                            </td>
                            <td>
                              Identity . Contact . Financial . Transaction
                            </td>
                            <td>(1) Performance of a contract with you</td>
                          </tr>
                          <tr>
                            <td>
                              (1) To manage our relationship with you,
                              including: providing you with any information,
                              products and services that you request from us(or
                              that has been requested on your behalf through our
                              "refer a friend" function);
                            </td>
                            <td>
                              Identity . Contact . Profile . Marketing and
                              Communications
                            </td>
                            <td>(1) Consent</td>
                          </tr>
                          <tr>
                            <td>
                              To enable you to take part in a competition,
                              event, survey, or receive a reward for shopping
                              with us.
                            </td>
                            <td>
                              Identity . Contact . Profile . Usage . Marketing
                              and Communications
                            </td>
                            <td>
                              Where you have decided to enter into a competition
                              or event, for the performance of a contract with
                              you
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Where you purchase products from one of the
                              Concessionaire Brands, to enable the relevant
                              Concessionaire Brand to fulfil their order with
                              you (for example, to deliver the products, deal
                              with collection and returns and/or any issues or
                              complaints you may have in relation to the
                              products).
                            </td>
                            <td>Identity . Contact . Transaction</td>
                            <td />
                          </tr>
                          <tr>
                            <td>
                              Where you purchase products from one of the
                              Concessionaire Brands, to enable us to keep
                              up-to-date with your order status and track your
                              order, receive proof of delivery for products
                              shipped to you, provide you with tracking
                              information and to perform invoice reconciliation.
                            </td>
                            <td>Identity . Contact . Transaction</td>
                            <td>Performance of a contract with you</td>
                          </tr>
                          <tr>
                            <td>
                              To assist with any queries or complaints you may
                              have, including where you have purchased products
                              from the Concessionaire Brands.
                            </td>
                            <td>Identity . Contact . Transaction</td>
                            <td>Performance of a contract with you</td>
                          </tr>
                          <tr>
                            <td>
                              To administer, protect and improve our business
                              and our website/app, including: troubleshooting,
                              data analysis, testing, system maintenance,
                              support, data analysis, reporting and hosting of
                              data; setting default options for you, such as
                              language and currency.
                            </td>
                            <td>
                              Identity . Contact . Profile . Technical .
                              Transaction . Marketing and Communications
                            </td>
                            <td>Consent</td>
                          </tr>
                          <tr>
                            <td>
                              To deliver relevant website content, online
                              advertisements and information for you; and
                              measure the effectiveness of the advertising
                              provided.
                            </td>
                            <td>
                              Identity . Contact . Profile . Usage . Marketing
                              and Communications . Technical
                            </td>
                            <td>Consent</td>
                          </tr>
                          <tr>
                            <td>
                              To use data analytics to: improve our website,
                              products, services, marketing, customer
                              relationships and experiences; and to improve our
                              affiliated group companies’ websites, products,
                              services, marketing, customer relationships and
                              experiences; and for market research, statistical
                              and survey purposes.
                            </td>
                            <td>
                              Identity . Contact . Profile. Technical . Usage
                            </td>
                            <td>
                              Consent Legitimate interests (to improve our
                              websites, products, services, marketing, customer
                              relationships and experiences, and those of our
                              affiliated group companies)
                            </td>
                          </tr>
                          <tr>
                            <td>
                              To recommend our products, services, discounts and
                              offers and any products, services, discounts and
                              offers provided by our affiliated group companies,
                              that may be of interest to you, including to send
                              you such information by email, post or SMS.
                            </td>
                            <td>
                              Identity . Contact . Technical . Usage . Profile .
                              Marketing and Communications
                            </td>
                            <td>
                              Consent (we always give you the choice of whether
                              or not you wish to receive marketing
                              communications from us (for example by providing
                              opportunities to opt-out of receiving marketing
                              from us).
                              <div>
                                <p
                                  className="mx-auto px-6"
                                  node="[object Object]"
                                >
                                  Legitimate interests (when we share data with
                                  credit reference agencies, to ensure credit
                                  products are offered to customers who are
                                  suitable for it)
                                </p>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              To inform or remind you by email of any task
                              carried out via our website which remains
                              uncompleted, such as incomplete orders or
                              abandoned baskets.
                            </td>
                            <td>Identity . Contact . Usage</td>
                            <td>
                              Consent (by providing the opportunity to opt-out
                              of receiving such reminders from us).
                            </td>
                          </tr>
                          <tr>
                            <td>
                              To process and deliver your e-gift card orders
                              including taking payment and communicating with
                              you and/or the nominated recipient if delivered to
                              another person.
                            </td>
                            <td>
                              Identity . Contact . Financial . Transaction
                            </td>
                            <td>Performance of a contract with you</td>
                          </tr>
                          <tr>
                            <td>
                              We may disclose your information to other
                              companies in connection with any merger,
                              acquisition, insolvency situation or otherwise, in
                              which case we will only disclose your information
                              so far as is necessary.
                            </td>
                            <td>
                              Identity . Contact . Profile . Usage . Marketing
                              and Communications . Technical
                            </td>
                            <td>
                              Legitimate interest (we have a legitimate interest
                              in processing your information in connection with
                              any mergers, acquisitions or reorganisation of our
                              business, in which case some of your information
                              may be shared with a prospective buyer or
                              otherwise but only so far as is strictly necessary
                              for the purposes of such sale or administration).
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We will only use your personal data for the purposes
                          for which we collected it, unless we reasonably
                          consider that we need to use it for another reason and
                          that reason is compatible with the original purpose.
                          If we wish to use your personal data for an unrelated
                          purpose, we will notify you and we will explain the
                          legal basis which allows us to do so. We may process
                          personal data without your consent, in compliance with
                          the above rules, where this is required or permitted
                          by law.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you have any questions about how Boventraix use any
                          of your personal data, please contact our Data
                          Protection Officer at{" "}
                          <Link
                            onClick={toTop}
                            to="mailto:style@boventraix.space"
                          >
                            style@boventraix.space
                          </Link>
                        </p>
                      </div>
                      <h4>How long we keep your data for</h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We will keep your personal data for no longer than is
                          necessary for the purpose(s) it was provided for and
                          to meet our legal obligations. Further details of the
                          periods for which we retain data are available on
                          request.
                        </p>
                      </div>
                      <h3>Marketing preferences, adverts and cookies</h3>
                      <h4>Marketing - your preferences</h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We may send you marketing communications and
                          promotional offers:
                        </p>
                      </div>
                      <ul>
                        <li>
                          if you have opened an account with us or purchased
                          goods from us, or registered for a promotion or event,
                          and you have not opted out of receiving that
                          marketing;
                        </li>
                        <li>
                          by email if you have signed up for email newsletters;
                        </li>
                        <li>
                          if you have provided us with your details when you
                          entered a competition and you have consented to
                          receiving such marketing (in accordance with your
                          preferences, as explained below).
                        </li>
                      </ul>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We may use your Identity, Contact, Technical,
                          Transactional, Usage, Profile Data and Marketing and
                          Communications Data to form a view on what we think
                          you may like, or what may be of interest to you, and
                          to send you details of products and offers which may
                          be relevant for you.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We may check your details with appropriate third
                          parties (for example credit reference agencies, such
                          as Experian) before we send you promotions for
                          financial services products. This is to ensure your
                          information is accurate, that the product is suitable
                          for you, and to tailor those offers to you.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          From time to time we may also include with your order,
                          inserts advertising goods, services or offers from
                          other third-party companies that you may be interested
                          in.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          You will always have full control of your marketing
                          preferences. If you do not wish to continue receiving
                          marketing information from us or any of our affiliated
                          group companies (or any third party, if applicable) at
                          any time:
                        </p>
                      </div>
                      <ul>
                        <li>
                          you can unsubscribe or ‘opt-out’ by using the
                          unsubscribe button and following the link included in
                          the footer of any marketing email; or
                        </li>
                        <li>
                          You may also unsubscribe by heading over to our{" "}
                          <Link onClick={toTop} to="/contact">
                            contact us
                          </Link>{" "}
                          section and confirming to our team your preferences to
                          opt-out.
                        </li>
                      </ul>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We will process all opt-out requests as soon as
                          possible, but please note that due to the nature of
                          our IT systems and servers it may take a few days for
                          any opt-out request to be implemented.
                        </p>
                      </div>
                      <h4>Cookies</h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Our website uses cookies to distinguish you from other
                          users of our website and to keep track of your visits.
                          They help us to provide you with the very best
                          experience when you browse our website and to make
                          improvements to our website. They also help us and our
                          advertising networks to make advertising relevant to
                          you and your interests.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          You can set your browser to refuse all or some browser
                          cookies, or to alert you when websites set or access
                          cookies. If you disable or refuse cookies, please note
                          that some parts of our website may become inaccessible
                          or not function properly.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          For detailed information on the cookies which we and
                          our third-party providers use and the reasons why we
                          use them, please refer to our Cookie Policy.
                        </p>
                      </div>
                      <h4>Online ads</h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We use online advertising to keep you aware of what
                          we’re up to and to help you find our products. Like
                          many companies, we may target Debenhams banners and
                          ads to you when you use other websites and apps, based
                          on your Contact, Technical, Usage and Profile Data. We
                          do this using a variety of digital marketing networks
                          and ad exchanges, and a range of advertising
                          technologies such as web beacons, pixels, ad tags,
                          cookies, and mobile identifiers, as well as specific
                          services offered by some sites and social networks,
                          such as Facebook’s Custom Audience Service.
                        </p>
                      </div>
                      <h4>
                        Our use of analytics and targeted advertising tools
                      </h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We use a range of analytics and targeted advertising
                          tools to display relevant website content on our
                          website and online advertisements on other websites
                          and apps (as described above) to you, deliver relevant
                          content to you in marketing communications (where
                          applicable), and to measure the effectiveness of the
                          advertising provided. For example, we use tools such
                          as Google Analytics to analyse Google's interest-based
                          advertising data and/or third-party audience data
                          (such as age, marital status, life event, gender and
                          interests) to target and improve our marketing
                          campaigns, marketing strategies and website content.
                          We may also use tools provided by other third parties,
                          such as Facebook, Content Square, Adroll, Bloomreach,
                          Criteo and Bing to perform similar tasks, using your
                          Contact, Technical, Usage and Profile Data.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          In order to opt out of targeted advertising you need
                          to disable your ‘cookies’ in your browser settings
                          (see Cookie Policy for details) or opt-out of the
                          relevant third-party Ad Settings. For example, you can
                          opt-out of the Google Display Advertising Features. As
                          an added privacy measure, you can also use the The
                          Digital Advertising Alliance (which includes companies
                          such as Google, Bloomreach and Facebook) provides a
                          tool called WebChoices that can perform a quick scan
                          of your computer or mobile devices, find out which
                          participating companies have enabled customised ads
                          for your browser, and adjust your browser preferences
                          accordingly.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you would like any further information about the
                          data collected by these third parties or the way in
                          which the data is used, please contact us.
                        </p>
                      </div>
                      <h3>Links to other websites and third parties</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Our website may include links to and from the websites
                          of our partner networks, Concessionaire Brands,
                          advertisers and affiliates, or to social media
                          platforms. If you follow a link to any of these
                          websites, please note that these websites have their
                          own privacy policies and that we do not accept any
                          responsibility or liability for these policies. Please
                          check these policies before you submit any personal
                          data to their websites.
                        </p>
                      </div>
                      <h3>How we share your data</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We may disclose and share your personal data with the
                          parties set out below:
                        </p>
                      </div>
                      <ul>
                        <li>
                          where you have consented for us to do so. For example,
                          if you have consented to receive marketing materials
                          from third parties, or in respect of third parties’
                          (including co-branded or jointly promoted) products
                          and services, we may pass your data on to the relevant
                          third parties for the purpose of sending you such
                          marketing communications;
                        </li>
                        <li>
                          to business partners, suppliers, sub-contractors and
                          other third parties that we use in connection with the
                          running of our business for the purposes set out in
                          the table above in the section ‘How we use your data’,
                          such as:
                        </li>
                        <li>
                          to Concessionaire Brands, who require your personal
                          data in order to perform their contract with you if
                          you purchase their products on our website (as set out
                          in the ‘How we use your data’ section above). When you
                          purchase Concessionaire Brand products from our
                          website, we only transmit to the relevant
                          Concessionaire Brand the personal data they require in
                          order to fulfil their contract to you. Please note
                          that the Concessionaire Brands have their own privacy
                          policies and we do not accept any responsibility or
                          liability for these policies nor their data processing
                          practices;
                        </li>
                        <li>
                          third party service providers that we engage to
                          provide IT systems and software, and to host our
                          website;
                        </li>
                        <li>
                          third party payment processing services (including
                          Ayden), and in some regions, Klarna (please see
                          T&amp;C’s{" "}
                          <Link onClick={toTop} to="/terms">
                            www.klarna.com/uk/terms-and-conditions/
                          </Link>
                          ) to process your payment to us. Debenhams does not
                          store your payment information. Your payment details
                          are provided to the payment processing service you
                          have selected, who are required to comply with
                          applicable regulations and data protection laws.
                          Please refer to the privacy policy of the relevant
                          provider for details of how they process your personal
                          data;
                        </li>
                        <li>
                          third party service providers that we engage to
                          deliver goods you have ordered and to manage any
                          returns;
                        </li>
                        <li>
                          third party service providers that we engage to send
                          emails and postal mail on our behalf including in
                          relation to incomplete orders or abandoned baskets, or
                          marketing communications, to provide data cleansing
                          services and to provide marketing and advertising
                          services;
                        </li>
                        <li>
                          analytics and search engine providers that assist us
                          in the improvement and optimisation of our website;
                        </li>
                        <li>
                          affiliate networks through whom you have accessed our
                          website;
                        </li>
                        <li>
                          to any third party to whom we may choose to sell,
                          transfer, or merge parts of our business or our
                          assets. Alternatively, we may seek to acquire other
                          businesses or merge with them. If a change happens to
                          our business, then the new owners may use your
                          personal data in the same way as set out in this
                          privacy notice.
                        </li>
                        <li>
                          to protect our customers, Debenhams group companies
                          and website from fraud and theft, we may share
                          personal data that is required to make identity checks
                          and personal data that we obtain from making identity
                          checks (including data relating to your age, name and
                          location), together with account information, with
                          other Debenhams group companies and with third party
                          organisations (including law enforcement agencies),
                          involved in fraud prevention and detection and credit
                          risk reduction. Please note that the other Debenhams
                          group companies and these third parties may retain a
                          record of the information that we provide to them for
                          this purpose;
                        </li>
                        <li>
                          we may share your personal data with Ravelin and/or
                          Risk Guardian and/or other fraud prevention and
                          analysis service providers, in order to carry out
                          fraud prevention checks on our behalf. If personal
                          data is provided to Ravelin, Ravelin will also use
                          this personal data to improve its service and machine
                          learning to improve its automated processing. A copy
                          of Ravelin's privacy notice can be found at:{" "}
                          <Link onClick={toTop} to="/privacy">
                            www.ravelin.com/privacy-policy
                          </Link>{" "}
                          explains how Ravelin will use your personal data for
                          these purposes;
                        </li>
                        <li>
                          we may further share personal data that is required to
                          make identity checks and personal data that we obtain
                          from making identity checks (including data relating
                          to your age, name and location), together with account
                          information, with organisations (including law
                          enforcement agencies), involved in fraud prevention
                          and detection and credit risk reduction. Please note
                          that these third parties may retain a record of the
                          information that we provide to them for this purpose;
                        </li>
                        <li>
                          if we are under a duty to disclose or share your
                          personal data in order to comply with any legal
                          obligation; or
                        </li>
                        <li>
                          to our professional advisers including lawyers,
                          bankers, auditors and insurers who provide
                          consultancy, banking, legal, insurance and accounting
                          services.
                        </li>
                      </ul>
                      <h3>Adyen</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Adyen are the data controller in respect of the
                          Personal Information that you give to them (and which
                          they hold about you) when you sign up for, access, or
                          use services, features, technologies or functions
                          offered on the Adyen website (including when using
                          Adyen to pay for goods or services offered on the
                          Debenhams website) and in relation to Personal
                          Information collected during the course of business as
                          set out in their Privacy Policy which can be found on
                          their website at{" "}
                          <Link onClick={toTop} to="/privacy">
                            privacy-policy
                          </Link>
                          .
                        </p>
                      </div>
                      <h3>Your data and countries outside of the UK</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          The personal data we collect from you may be
                          transferred to, and stored at, destinations outside
                          the UK using legally-provided mechanisms to lawfully
                          transfer data across borders. It may also be processed
                          by staff operating outside the UK who work for us or
                          for one of our suppliers. Such staff may be engaged
                          in, among other things, the fulfilment of your order,
                          the processing of your payment details and the
                          provision of support services. We will take all steps
                          necessary to ensure that your data is treated securely
                          and in accordance with this privacy notice.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Whenever we transfer personal data outside the UK, we
                          will ensure a similar degree of protection is afforded
                          to it by ensuring appropriate safeguards, as required
                          by law, are in place. We will be able to transfer your
                          personal data to countries that have been deemed to
                          provide an adequate level of protection for personal
                          data. More information can be found here:{" "}
                          <Link onClick={toTop} to="/">
                            https://ico.org.uk/for-organisations/guide-to-data-protection/guide-to-the-general-data-protection-regulation-gdpr/international-transfers/
                          </Link>
                          . Otherwise, we may use specific contractual clauses
                          approved for use in the UK which give personal data
                          the same protection as it has in in the UK. More
                          information about this is available here:{" "}
                          <Link onClick={toTop} to="/">
                            https://ico.org.uk/for-organisations/guide-to-data-protection/guide-to-the-general-data-protection-regulation-gdpr/international-transfers-after-uk-exit/sccs-after-transition-period/
                          </Link>
                          .
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Please contact us if you want further information on
                          the countries to which we may transfer personal data
                          and the specific mechanism used by us when
                          transferring your personal data outside the UK.
                        </p>
                      </div>
                      <h3>Your Rights</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          You have several rights under the data privacy
                          legislation. This includes, under certain
                          circumstances, the right to:
                        </p>
                      </div>
                      <ul>
                        <li>request access to your personal data</li>
                        <li>request correction of your personal data</li>
                        <li>request erasure of your personal data</li>
                        <li>
                          request restriction of processing of your personal
                          data
                        </li>
                        <li>request the transfer of your personal data</li>
                        <li>object to processing of your personal data</li>
                        <li>
                          request human intervention for automated decision
                          making
                        </li>
                        <li>
                          withdraw your consent to process your personal data
                        </li>
                      </ul>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Brief details of each of these rights are set out
                          below. If you wish to exercise any of these rights,
                          please email us at{" "}
                          <Link
                            onClick={toTop}
                            to="mailto:style@boventraix.space"
                          >
                            style@boventraix.space
                          </Link>
                          .
                        </p>
                      </div>
                      <h4>Request access to your personal data</h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          You have the right to obtain a copy of the personal
                          data we hold about you and certain information
                          relating to our processing of your personal data.
                        </p>
                      </div>
                      <h4>Request correction of your personal data</h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          You are entitled to have your personal data corrected
                          if it is inaccurate or incomplete. You can update your
                          personal data at any time by logging into your account
                          and updating your details directly, or by emailing us
                          at{" "}
                          <Link
                            onClick={toTop}
                            to="mailto:style@boventraix.space"
                          >
                            style@boventraix.space
                          </Link>
                          . In certain circumstances we may need to verify the
                          accuracy of the new data you provide to ㅤ
                        </p>
                      </div>
                      <h4>Request erasure of your personal data</h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          This enables you to request that Debenhams delete your
                          personal data, where there is no good reason for us
                          continuing to process it. Note, however, that we may
                          not always be able to comply with your request of
                          erasure for specific legal reasons which will be
                          notified to you, if applicable, at the time of your
                          request.
                        </p>
                      </div>
                      <h4>
                        Request restriction of processing of your personal data
                      </h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          You have a right to ask Debenhams to suspend the
                          processing of your personal data in certain scenarios,
                          for example if you want us to establish the accuracy
                          of the data, or you have objected to our use of your
                          data but we need to verify whether we have overriding
                          legitimate grounds to use it. Where processing is
                          restricted, we are allowed to retain sufficient
                          information about you to ensure that the restriction
                          is respected in future.
                        </p>
                      </div>
                      <h4>Request the transfer of your personal data</h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          You have the right to obtain a digital copy of your
                          personal data or request the transfer of your personal
                          data to another company. Please note though that this
                          right only applies to automated data which you
                          initially provided consent for us to use or where we
                          used the data to perform a contract with you.
                        </p>
                      </div>
                      <h4>Object to processing of your personal data</h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          You have the right to object to the processing of your
                          personal data where we believe we have a legitimate
                          interest in processing it (as explained above). You
                          also have the right to object to our processing of
                          your personal data for direct marketing purposes. In
                          some cases, we may demonstrate that we have compelling
                          legitimate grounds to process your data which override
                          your rights and freedoms.
                        </p>
                      </div>
                      <h4>
                        Request human intervention for automated decision making
                        and profiling
                      </h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          You have the right to request human intervention where
                          we are carrying out automated decision making when
                          processing your personal data. This form of processing
                          is permitted where it is necessary as part of our
                          contract with you, providing that appropriate
                          safeguards are in place or your explicit consent has
                          been obtained.
                        </p>
                      </div>
                      <h4>Withdrawal of consent</h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          You have the right to withdraw previously given
                          consent at any time where we are relying on consent to
                          process your personal data. However, this will not
                          affect the lawfulness of any processing carried out
                          before you withdraw your consent. If you withdraw your
                          consent, we may not be able to provide certain
                          products or services to you. We will advise you if
                          this is the case at the time you withdraw your
                          consent.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We will try to respond to all legitimate requests
                          within one month. Occasionally, it may take us longer
                          than a month if your request is particularly complex
                          or you have made a number of requests. In this case,
                          we will notify you and keep you updated. We may need
                          to request specific information from you to help us
                          confirm your identity and ensure your right to
                          exercise any of the above rights. This is a security
                          measure to ensure that personal data is not disclosed
                          to any person who has no right to receive it. We may
                          also contact you to ask you for further information in
                          relation to your request to speed-up our response.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          You will not have to pay a fee to access your personal
                          data (or to exercise any of the other rights).
                          However, we may charge a reasonable fee if your
                          request is clearly unfounded, repetitive or excessive.
                          Alternatively, we could refuse to comply with your
                          request in these circumstances.
                        </p>
                      </div>
                      <h4>Right to lodge a complaint</h4>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you have any concerns or complaints regarding the
                          way in which we process your data, please email us
                          directly at{" "}
                          <Link
                            onClick={toTop}
                            to="mailto:style@boventraix.space"
                          >
                            style@boventraix.space
                          </Link>
                          . You also have the right to make a complaint to the
                          Information Commissioner’s Office (ICO), the data
                          protection regulator in the UK{" "}
                          <Link onClick={toTop} to="/">
                            home
                          </Link>
                          . We would, however, appreciate the chance to deal
                          with your concerns before you approach the ICO, so
                          please do contact us in the first instance
                        </p>
                      </div>
                      <h3>Changes to this privacy notice</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          From time to time we may change this privacy notice.
                          If there are any significant changes we will post
                          updates on our website, applications or let you know
                          by email.
                        </p>
                      </div>
                      <h3>How to contact us</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We welcome feedback and are happy to answer any
                          questions you may have about your data.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Please send any questions, comments or requests for
                          more information to our nominated representative and
                          Data Protection Officer, who can be contacted at{" "}
                          <Link
                            onClick={toTop}
                            to="mailto:style@boventraix.space"
                          >
                            style@boventraix.space
                          </Link>
                          .
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          This privacy notice was last updated on 10th July 2022
                          (Version v1.11) boventraix.space UK Limited,
                          Registered Company Number: 05723154, UK VAT Number:
                          185 4874 61.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Privacy;
